
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import {appSettings as appSettingsAction} from 'redux/modules/app-settings/actions'
import {connect} from 'react-redux'
import Logo from 'components/Logo'

class MaintenanceView extends React.Component {
  static propTypes = {
  }

  static defaultProps = {
    successMessage: '',
    errorMessage: ''
  }

  componentDidMount() {
  }

  render() {
    return (
      <div className='app-settings-view'>
        <div className='app-settings-view_logo_container'>
          <Logo
            inverted
            link
            className='app-settings-view_logo'
            size='medium'
          />
        </div>
        <div className='app-settings-view_content'>
          <p>{this.renderContent()}</p>
        </div>
      </div>
    )
  }

  renderContent() {
    const errorMessage = 'Site is under maintenance.You will be automatically redirect to the site after the maintenance process has been finished.'
    return <span className='error'>{errorMessage}</span>
  }
}

const mapStateToProps = (state, props) => {
  const {location: {query}} = props
  const {type: secretType, secret} = query
  const {
    isFetching,
    successMessage,
    errorMessage
  } = state.appSettings

  return {
    isFetching,
    secretType,
    secret,
    successMessage,
    errorMessage
  }
}

const mapDispatchToProps = {
  appSettings: appSettingsAction
}

export default connect(mapStateToProps, mapDispatchToProps)(MaintenanceView)



// WEBPACK FOOTER //
// ./client/views/MaintenanceView/index.js